<template>
    <div class="qf-plan d-flex flex-column pt-4 pb-3 px-3 text-uppercase">
        <div>
            <h2>
                {{plan.plan_name}}
            </h2>
        </div>
        <div class="d-flex justify-content-center py-4 qf-plan-price">
            <div>$</div>
            <div class="qf-plan-big-price">
                {{plan.yearly_price | priceNote}}
            </div>
            <div class="d-flex flex-column">
                <div class="text-left">{{plan.yearly_price | priceCent}}</div>
                <div class="text-lowercase">/{{$ml.get('year')}}</div>
            </div>
        </div>
        <div v-for="feature in plan.features" class="mb-2" :key="`feature${feature.id}`">
            {{feature.feature}}
        </div>
        <div class="mt-auto pt-5">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Plan",
        props: {
            plan: Object
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .qf-plan {
        background: #DFE0E1;
        text-align: center;
        width: 300px;
        min-height: 435px;
        margin: 0 5px;
        transition: 0.5s all;
        position: relative;
        z-index: 1;
        color: #002e42;
    }

    .qf-plan:not(.qf-no-hover):hover {
        transform: scale(1.1) translateY(-10px);
        box-shadow: 0 0 25px #5F6061;
        z-index: 2;
    }

    .qf-plan-big-price {
        font-size: 70px;
        line-height: 60px;
    }

    .qf-plan-price {
        font-size: 20px;
    }

</style>